// src/ui/Table.js
import styled from 'styled-components';

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
`;

export const Thead = styled.thead`
  background-color: ${({ theme }) => theme.colors.background};
`;

export const TH = styled.th`
  background-color: ${({ theme }) => theme.colors.tableHeaderBg};
  border: ${({ theme }) => theme.borders.sm};
  padding: ${({ theme }) => theme.spacing[2]}px;
`;

export const TD = styled.td`
  border: ${({ theme }) => theme.borders.sm};
  padding: ${({ theme }) => theme.spacing[2]}px;
`;

export const ROW = styled.tr`
  &:nth-child(odd) {
    background-color: ${({ theme }) => theme.colors.background};
  }
  &:nth-child(even) {
    background-color: ${({ theme }) => theme.colors.surfaceLight};
  }
`;
